import { Lock } from "@scoach/ui/icons";
import { useNavigate } from "@tanstack/react-router";

import { signOut } from "../../../lib/firebase.ts";
import { useAuthStore } from "../store.ts";

function useSignOut() {
  const nav = useNavigate();
  const clear = useAuthStore((s) => s.clear);
  return async () => {
    try {
      await signOut();
    } catch {
      /* dev mode */
    }
    clear();
    nav({ to: "/signin" });
  };
}

function GateShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-blob b1" />
        <div className="auth-blob b2" />
        <div className="auth-blob b3" />
        <div className="auth-blob b4" />
        <div className="auth-grid" />
      </div>
      <div className="auth-shell">{children}</div>
    </div>
  );
}

export function PendingApprovalScreen() {
  const email = useAuthStore((s) => s.user?.email ?? s.email);
  const doSignOut = useSignOut();
  return (
    <GateShell>
      <h1 className="auth-headline">Access requested ✓</h1>
      <p className="auth-sub">
        Thanks{email ? `, ${email}` : ""}! Your request to use Sally has been sent to the
        administrators. You'll be able to start as soon as it's approved — please check back soon.
        You can close this tab; sign in again later to see if you've been approved.
      </p>
      <div className="auth-actions">
        <button type="button" className="pill-btn" onClick={doSignOut}>
          Sign out
        </button>
      </div>
    </GateShell>
  );
}

export function BlockedScreen() {
  const doSignOut = useSignOut();
  return (
    <GateShell>
      <h1 className="auth-headline">
        <Lock size={20} /> Access blocked
      </h1>
      <p className="auth-sub">
        Your access to Sally has been disabled by an administrator. If you think this is a mistake,
        please contact your Sally admin.
      </p>
      <div className="auth-actions">
        <button type="button" className="pill-btn" onClick={doSignOut}>
          Sign out
        </button>
      </div>
    </GateShell>
  );
}
